import styled from 'styled-components';

export const ElementContainer = styled.div`
  margin-bottom: 16px;
  & > div:first-child {
    margin-bottom: 12px;
  }
`;

export const MainWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 20px;
  }
  & > div:last-child {
    flex-wrap: wrap;
  }
`;
